var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgItalicHover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    rx: 2,
    fill: "#DFE7C1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.07227 14.4V12.6H7.07227L9.39727 5.39998H6.32227V3.59998H13.9723V5.39998H11.1973L8.87227 12.6H11.7223V14.4H4.07227Z",
    fill: "#2D3245"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgItalicHover);
export default __webpack_public_path__ + "static/media/Italic-Hover.11e1155758184a9093559ef2c39d6cb2.svg";
export { ForwardRef as ReactComponent };